import { Button, chakra, Text, VStack } from "@chakra-ui/react"
import Pathicon from "@pathwright/web/src/modules/pathicon/Pathicon"
import { ActionType } from "../../../../lib/types"
import { useSpaceContext } from "../../../space/api/context"
import AuthFormAlert from "../../components/AuthFormAlert"
import AuthFormButton from "../../components/AuthFormButton"
import AuthFormHeading from "../../components/AuthFormHeading"
import AuthMotion from "../../components/AuthMotion"
import useColorModeBranding from "../../utils/useColorModeBranding"
import PasswordsForm from "../change/PasswordsForm"

const PasswordCreateView = ({
  loading,
  success,
  error,
  onSubmit,
  onContinue,
  onCancel,
  showHeading = true
}: ActionType & {
  onContinue: Function
  onCancel?: Function
  showHeading?: boolean
}) => {
  const colorScheme = useColorModeBranding()
  const { user } = useSpaceContext()

  if (success) {
    return (
      <AuthMotion>
        <VStack spacing={4}>
          <Pathicon icon="check-circle-fill" color="border" size={30} />
          <AuthFormHeading>Password updated</AuthFormHeading>
          <Text>You can use your new password to sign-in from now on.</Text>
          <Button
            variant="solid"
            colorScheme={colorScheme}
            onClick={() => onContinue()}
            width="full"
          >
            Continue
          </Button>
        </VStack>
      </AuthMotion>
    )
  }

  return (
    <AuthMotion>
      <chakra.form onSubmit={onSubmit} width="100%">
        <VStack spacing={4} width="100%">
          <AuthFormAlert error={error} />
          {showHeading && (
            <VStack spacing={4} width="100%">
              <AuthFormHeading>Create a new password</AuthFormHeading>
              <Text textAlign="center">
                Passwords must be at least ten characters.
              </Text>
              <Text>
                <b>Email:</b> {user?.email}
              </Text>
            </VStack>
          )}
          <PasswordsForm isSubmitting={loading}>
            <AuthFormButton loading={loading}>Update Password</AuthFormButton>
            {!!onCancel && (
              <Button variant="solid" onClick={() => onCancel()} width="full">
                Cancel
              </Button>
            )}
          </PasswordsForm>
        </VStack>
      </chakra.form>
    </AuthMotion>
  )
}

export default PasswordCreateView
